import { IsiIWSScreen } from "./Isilog/Core/IsiIwsUICore";
import { IsiPresentationLogic } from "./Isilog/PresentationLogic/IsiPresentationLogic";

export function getPl(plName: string): Promise<IsiPresentationLogic> {

    return new Promise((resolve: (pl: IsiPresentationLogic) => void, reject): void => {
         import(
            /* webpackChunkName: "/Isilog/PresentationLogic/[request]" */
             `./Isilog/PresentationLogic/${plName}`).then((module) => {
                 resolve(new module[plName]());
             }).catch((e) => {
                 console.log(e);
             });
    });

}
